<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZCCpI8/tc-custom/9780740793271.jpg?1704761694379" alt="This image is the cover for the book Secret Language of Knitters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Secret Language of Knitters
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The expert knitter and author of <i>Hooked for Life</i> shares an irreverent guide to the loopy world of knitting jargon from “Acrylic” to “Yarn Porn”.</b></p><p> If you’ve ever wanted to know what knitters <i>really </i>mean when they say “frog”, “WIP”, or “stash”, <i>The Secret Language of Knitters</i> is for you. Written by acclaimed crafting author Mary Beth Temple, this dictionary will make you laugh as you learn the ins and outs of knitting terminology. Ideal for the knitting novice as well as the yarn-obsessed, it includes entries such as: </p><p> * <b>Design Elements</b> noun: Mistakes. As in “The fact that one sleeve is five inches longer than the other is not a mistake, it is a design element.” </p><p><b>* Moth</b> noun: The devil incarnate, eater of both stash and finished objects. Should be treated with a zero-tolerance attitude. </p><p> * <b>Stress Knitting</b> noun: When the going gets tough, the tough get knitting. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Beth Temple
      </h2>
      
      <p class="authorDescription body article">Mary Beth Temple has been knitting since she was seven years old. She is the author of four books including Hooked for Life: Adventures of a Crochet Zealot, and Rescuing Vintage Textiles and hosts the internet radio show Getting Loopy.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?56720c22